import React, {useState, CSSProperties, ReactNode} from "react";

interface HoverWrapperProps {
    children: ReactNode;
    tooltipText?: string;
    tooltipPosition?: 'top' | 'bottom' | 'left' | 'right';
    tooltipStyle?: CSSProperties;
    wrapperStyle?: CSSProperties;
}

const HoverWrapper: React.FC<HoverWrapperProps> = ({
                                                       children,
                                                       tooltipText = "Tooltip",
                                                       tooltipPosition = "top",
                                                       tooltipStyle = {},
                                                       wrapperStyle = {}
                                                   }) => {
    const [isHovered, setIsHovered] = useState<boolean>(false);

    const getPositionClasses = (): string => {
        switch (tooltipPosition) {
            case "bottom":
                return "top-full left-1/2 transform -translate-x-1/2 mt-2";
            case "left":
                return "top-1/2 right-full transform -translate-y-1/2 -mr-2";
            case "right":
                return "top-1/2 left-full transform -translate-y-1/2 ml-2";
            case "top":
            default:
                return "-top-12 left-1/2 transform -translate-x-1/2";
        }
    };

    return (
        <div
            className="relative inline-block"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={wrapperStyle}
        >
            {children}

            {isHovered && (
                <div
                    className={`absolute ${getPositionClasses()} backdrop-blur-md bg-white bg-opacity-60 border border-white border-opacity-30 py-2 px-4 rounded-lg shadow-sm text-sm whitespace-nowrap z-50`}
                    style={tooltipStyle}
                >
                    {tooltipText}
                </div>
            )}
        </div>
    );
};

export default HoverWrapper;